import { useEffect, useState } from "react";

import { Progress, WorldCupBar, GameBody } from "../components";

import { useNavigate } from "react-router-dom";

const gameData = [
  { id: 0, name: "mountain99", image: "/worldcup/imgs/man/mountain99.webp" },
  { id: 1, name: "치키차카", image: "/worldcup/imgs/man/치키차카.webp" },
  { id: 2, name: "카르디아", image: "/worldcup/imgs/man/카르디아.webp" },
  { id: 3, name: "MYMU", image: "/worldcup/imgs/man/MYMU.webp" },
  { id: 4, name: "헬로우월드", image: "/worldcup/imgs/man/헬로우월드.webp" },
  { id: 5, name: "크리드", image: "/worldcup/imgs/man/크리드.webp" },
  { id: 6, name: "kws0417", image: "/worldcup/imgs/man/kws0417.webp" },
  { id: 7, name: "besmile", image: "/worldcup/imgs/man/besmile.webp" },
  { id: 8, name: "둥굴", image: "/worldcup/imgs/man/둥굴.webp" },
  { id: 9, name: "milky", image: "/worldcup/imgs/man/milky.webp" },
  {
    id: 10,
    name: "하얀돌고래",
    image: "/worldcup/imgs/man/하얀돌고래.webp",
  },
  { id: 11, name: "리트리버", image: "/worldcup/imgs/man/리트리버.webp" },
  {
    id: 12,
    name: "유자차",
    image: "/worldcup/imgs/man/유자차.webp",
  },
  {
    id: 13,
    name: "내가그린그림",
    image: "/worldcup/imgs/man/내가그린그림.webp",
  },
  { id: 14, name: "마인", image: "/worldcup/imgs/man/마인.webp" },
  { id: 15, name: "동그리", image: "/worldcup/imgs/man/동그리.webp" },
];

export default function Man() {
  const TOTAL_ROUND = 15;
  const navigator = useNavigate();
  const [result, setResult] = useState(false);
  const [gameProgress, setGameProgress] = useState({
    game16: [],
    game8: [],
    game4: [],
    game2: [],
    last: [],
  });
  const [completedRound, setCompletedRound] = useState(0);
  const [progressRound, setProgressRound] = useState(null);
  const [selectedCards, setSelectedCards] = useState([]);
  const [remainingCards, setRemainingCards] = useState(gameData);

  const initializeGame = () => {
    const shuffled = remainingCards.sort(() => 0.5 - Math.random());
    const selected = shuffled.slice(0, 2);
    setGameProgress((prev) => ({ ...prev, game16: shuffled }));
    setSelectedCards(selected);
  };
  const startGame = (list, result) => {
    const remaining = remainingCards.slice(2);

    if (gameProgress.game8.length < 8) {
      setGameProgress((prev) => ({
        ...prev,
        game8: [...prev.game8, list],
      }));
    } else if (
      gameProgress.game4.length < 4 &&
      gameProgress.game8.length === 8
    ) {
      setGameProgress((prev) => ({
        ...prev,
        game4: [...prev.game4, list],
      }));
    } else if (
      gameProgress.game2.length < 2 &&
      gameProgress.game4.length === 4
    ) {
      setGameProgress((prev) => ({
        ...prev,
        game2: [...prev.game2, list],
      }));
    } else if (
      gameProgress.game2.length === 2 &&
      gameProgress.last.length === 0
    ) {
      setGameProgress((prev) => ({
        ...prev,
        last: [list],
      }));
    }

    setRemainingCards(remaining);
    setCompletedRound((prev) => {
      return prev + 1;
    });
    if (result) {
      setResult(true);
    }
  };

  useEffect(() => {
    initializeGame();
    gameData.forEach(({ image }) => {
      const img = new Image();
      img.src = image;
    });
  }, []);
  useEffect(() => {
    if (gameProgress.game8.length === 8 && gameProgress.game4.length === 0) {
      setRemainingCards(gameProgress.game8);
      setCompletedRound(0);
    } else if (
      gameProgress.game4.length === 4 &&
      gameProgress.game2.length === 0
    ) {
      setRemainingCards(gameProgress.game4);
      setCompletedRound(0);
    } else if (
      gameProgress.game2.length === 2 &&
      gameProgress.last.length === 0
    ) {
      setRemainingCards(gameProgress.game2);
      setCompletedRound(0);
    }
    setSelectedCards(remainingCards.slice(0, 2));
    const progressRound = (completedRound / TOTAL_ROUND) * 100;
    setProgressRound(progressRound.toFixed(0));

    if (result) {
      const url = new URLSearchParams();
      url.append("image", gameProgress.last[0].image);
      url.append("name", gameProgress.last[0].name);
      url.append("id", gameProgress.last[0].id);
      const query = url.toString();
      navigator(`/result?${query}`);
    }
  }, [remainingCards]);
  const round = () => {
    if (gameProgress.game8.length < 8) return "1라운드";
    if (gameProgress.game4.length < 4) return "2라운드";
    if (gameProgress.game2.length < 2) return "3라운드";
    if (gameProgress.game2.length === 2) return "결승";
  };
  return (
    <>
      <Progress
        round={round}
        progressRound={progressRound}
        gameProgress={gameProgress}
        completedRound={completedRound}
      />
      <div
        className="container gameContainer"
        style={{
          borderRadius: "20px",
          position: "relative",
          paddingTop: 0,
          background: "#fff",
        }}
      >
        <GameBody
          gameData={selectedCards}
          startGame={startGame}
          result={gameProgress.game2.length === 2 && true}
        />
      </div>
    </>
  );
}
